export const DOCUMENT = 0;
export const CV = 1;
